<script lang="ts">
    import { computed, ref, onMounted, reactive } from 'vue';
    import vm, { JourneyNode } from '@journeys/Journeys.viewmodel';

    import { NodeTaskVariation, StepTypes } from '@journeys/Enums';

    import { ConditionOptions } from './ConditionList';
    // components
    // import List from "@shared/components/ListDynamic.vue"
    import NodePresetList from './Partials/NodePresetList.vue';
    // import FluidButton from '@shared/components/FluidButton.vue'
    import FluidSelect from '@shared/components/FluidSelect.vue';
    import FluidInput from '@shared/components/FluidInput.vue';
    import FluidTextarea from '@shared/components/FluidTextarea.vue';
    import NativeSelect from '@shared/components/NativeSelect.vue';
    import SelectMany from '@shared/components/SelectMany/SelectMany.vue';

    import HumanTime from '@shared/utils/HumanTime/HumanTime';

    import Modal from '@shared/components/Modal.vue';
    import SelectIssueFromList from '@shared/components/SelectIssueFromList.vue';

    const time = new HumanTime();

    // assets
    import { ArrowLeftSVG } from '@shared/assets/vector/ui/IconsUI';
    import { api } from '@cwd/lib/main';
    import FluidButton from '@shared/components/FluidButton.vue';
    import FluidToggle from '@shared/components/FluidToggle.vue';
    import { watch } from 'vue';

    const component: any = {
        name: 'Partial_TaskNodeSettings',
        fetched: {},
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const { editor, nav, settings, account, activeJourney } = vm;

    const props = defineProps<{
        data: any;
        id: number;
    }>();

    const timeSpanSince = ref(0);
    const timeSpanSinceInvalid = ref(false);

    const handleTimeSpanSinceChange = (value?: string) => {
        if (!value) {
            timeSpanSince.value = 0;
            return;
        }
        timeSpanSince.value = +value;
        if (+value < 1) {
            timeSpanSinceInvalid.value = true;
        } else {
            timeSpanSinceInvalid.value = false;
            props.data.TimeSpanSince = value.toString();
        }
    };

    watch(
        () => props.data.resendToExistingRecipients,
        (newVal) => {
            if (newVal && !props.data.TimeSpanSince) {
                props.data.TimeSpanSince = 30;
                timeSpanSince.value = 30;
            } else if (!newVal) {
                timeSpanSince.value = 0;
                props.data.TimeSpanSince = null;
            }
        }
    );

    watch(
        () => props.data,
        (newVal) => {
            if (newVal.TimeSpanSince) {
                timeSpanSince.value = newVal.TimeSpanSince;
                if (+timeSpanSince.value < 30) {
                    timeSpanSinceInvalid.value = true;
                } else {
                    timeSpanSinceInvalid.value = false;
                }
            }
        }
    );

    let stepTypes: { [key: string]: { id: number; name: string } } = {};

    for (var type in StepTypes) {
        if (typeof StepTypes[type] === 'number') {
            stepTypes[StepTypes[type]] = {
                id: parseInt(StepTypes[type]),
                name: type,
            };
        }
    }

    onMounted(() => {
        // TODO conditional fetch when needed
        // **** this does work kinda well though... make portable & generic
        // **** do a class!
        // if (!component.fetched.surveys || Date.now() - component.fetched.surveys > 300000)
        //    api.get('/surveys').then((data:any) => {
        //       account.lists.surveys = data.reduce((acc: any, s: any) => (acc[s.SurveyId] = s, acc), {})
        //       component.fetched.surveys = Date.now()  // replacable
        //    })
        if (props.data.TimeSpanSince) {
            timeSpanSince.value = props.data.TimeSpanSince;
        }
    });

    const usedIssues = computed(() => {
        let steps = activeJourney.steps,
            res: { [key: string]: any } = {};

        for (let key in steps) {
            if (typeof steps[key] === 'number') {
                const issueId = (activeJourney.nodes[key] as JourneyNode).data.IssueId;
                if (issueId) {
                    res[issueId] = steps[key];
                }
            } else if (steps[key].data.IssueId) {
                res[steps[key].data.IssueId] = steps[key].nodeId;
            }
        }

        return res;
    });

    const formatItemName = (subject: string, name: string, description: string, timestamp: string) => {
        let res = [];

        if (subject) res.push(subject);
        if (name) res.push(name);
        if (!subject && !name) res.push($Resources.NoTitleLabel);
        if (description) res.push(description);

        res.push(timestamp);

        return res.join(' | ');
    };

    const state = reactive({
            page: 0,
            pageSize: 20,
            showSelectorModal: false,
        }),
        fetchLatest = (): any => {
            let listings;
            if (props.data.var === NodeTaskVariation.Survey) listings = account.listings.get('/surveys/listing');
            else if (props.data.var === NodeTaskVariation.Sms) listings = account.listings.get('/textmessages/listing');
            else if (props.data.var === NodeTaskVariation.Event) listings = account.listings.get('/events/listing');
            else listings = account.listings.get('/issues/listing');

            return listings;
        },
        filteredListings = computed(() => {
            let listings = fetchLatest();

            if (!Array.isArray(listings)) return;

            const journeyId = vm.activeJourney.JourneyId;

            if (props.data.var === NodeTaskVariation.Email) {
                listings = listings.filter((listing) => {
                    return listing.Status === 10 && (listing.Journey === null || listing.Journey.JourneyId === journeyId);
                });
            }

            listings = listings.reduce((acc: any[], item: any, idx: number) => {
                // if (idx < state.showItems)
                acc.push(item);

                return acc;
            }, []);

            // return listings
            return [...listings]; // .sort(sortComparer) // temp sorting fix
        });

    // const sortComparer = (l: any, r: any) => (l['LastModified'] < r['LastModified'] ? 1 : -1)

    const _c1 = () => {
        state.page = state.page * state.pageSize > 200 ? ((state.pageSize = 200), 0) : state.page + 1;
        fetchLatest();
    };

    const selectedObjectStats = computed(() => {
       
        if (props.data.var === NodeTaskVariation.Email && props.data.IssueId) {
            const stats = account.listings.getStatistics(props.data.IssueId);
            // Return a reactive copy of the statistics to ensure Vue detects changes
            return stats ? { ...stats } : null;
        }
        return null;
    });
    
    const selectedObject = computed(() => {
        if (props.data.var === NodeTaskVariation.Email && props.data.IssueId) {
            return account.listings.getListing('/issues/listing', props.data.IssueId);
        }
        if (props.data.var === NodeTaskVariation.Sms && props.data.SmsMessageId) {
            return account.listings.getListing('/textmessages/listing', props.data.SmsMessageId);
        }
        if (props.data.var === NodeTaskVariation.Survey && props.data.SurveyId) {
            return account.listings.getListing('/surveys/listing', props.data.SurveyId);
        }
        if (props.data.var === NodeTaskVariation.Event && props.data.EventId) {
            return account.listings.getListing('/events/listing', props.data.EventId);
        }

        return null;
    });

    const setId = (data: any, newVal: string) => {
        state.showSelectorModal = false;

        switch (data.var) {
            case NodeTaskVariation.Event:
                return (data.EventId = newVal);
            case NodeTaskVariation.Survey:
                return (data.SurveyId = newVal);
            case NodeTaskVariation.Sms:
                return (data.SmsMessageId = newVal);
            default:
                return (data.IssueId = newVal);
        }
    };

    const getType = (type: number) => {
        switch (type) {
            case NodeTaskVariation.Event:
                return 'events';
            case NodeTaskVariation.Survey:
                return 'surveys';
            case NodeTaskVariation.Sms:
                return 'sms';
            default:
                return 'issues';
        }
    };
</script>

<template>
    <div class="section-group">
        <!--
		<h3 class="title mb-sm" style="margin-bottom: 0.75rem">{{ $Resources.NodeTaskSettings }}</h3>
        -->

        <template v-if="data.var === NodeTaskVariation.Event">
            <template v-if="selectedObject">
                <fieldset class="fieldset m-lg-t">
                    <legend>{{ $Resources.SelectedEventLabel }}</legend>
                    <!-- {{ $.fn }} -->
                    <div class="list-cell">
                        <h3 class="h4 m-0-t d-flex col-gap-xs flex-wrap align-items-baseline">
                            <a :href="`/events/${selectedObject.EventId}/statistics`" target="_blank">{{ selectedObject.Name || $Resources.NoTitleLabel }}</a>
                            <a
                                role="button"
                                class="btn btn-subtle btn-xs"
                                :href="`${api.settings.publicHost}/Events/${selectedObject.EventId}?preview=true`"
                                target="_blank">
                                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
                            </a>
                        </h3>

                        <p v-if="selectedObject.Description" class="info-wrapper description">
                            {{ selectedObject.Description }}
                        </p>

                        <SelectMany
                            v-if="selectedObject.Tags?.length"
                            class="listing m-sm-b"
                            style="margin-left: -5px; margin-top: -10px"
                            mode="display"
                            :list="account.listings.getMap('/tags')"
                            v-model:selectedItems="selectedObject.Tags"
                            selectionProp="TagId"
                            displayProp="Title" />

                        <p class="meta">
                            <span class="glyphicon glyphicon-time"></span>
                            <span class="ml-xxs">
                                <time :datetime="selectedObject.LastModified">{{ time.parse(selectedObject.LastModified) }}</time>
                            </span>
                            <span class="glyphicon glyphicon-user"></span>
                            <span class="ml-xxs">{{ selectedObject.LastModifiedBy.Name }}</span>
                        </p>
                    </div>
                </fieldset>
            </template>
            <div class="form-group">
                <FluidButton :text="$Resources.NodeTaskChooseEvent" @click="state.showSelectorModal = true" class="btn btn-default"></FluidButton>
            </div>
        </template>
        <template v-else-if="data.var === NodeTaskVariation.Survey">
            <template v-if="selectedObject">
                <div class="fieldset">
                    <span class="label-look">{{ $Resources.SelectedSurveyLabel }}:</span>
                    <h3 class="h4 m-0-t d-flex col-gap-xs flex-wrap align-items-baseline">
                        <a :href="`/Surveys/${selectedObject.SurveyId}/Statistics`" target="_blank" rel="noopener">
                            {{ selectedObject.Title || $Resources.NoTitleLabel }}
                        </a>
                        <a
                            class="btn btn-subtle btn-xs"
                            :href="`${api.settings.publicHost}/Surveys/${selectedObject.SurveyId}?preview=true`"
                            target="_blank"
                            rel="noopener">
                            <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
                            <span class="sr-only">{{ $Resources.PreviewButton }}</span>
                        </a>
                    </h3>

                    <p v-if="selectedObject.SurveyName">
                        {{ selectedObject.SurveyName }}
                    </p>

                    <SelectMany
                        v-if="selectedObject.Tags && selectedObject.Tags.length"
                        class="listing m-sm-b"
                        style="margin-left: -5px; margin-top: -10px"
                        mode="display"
                        :list="account.listings.getMap('/tags')"
                        v-model:selectedItems="selectedObject.Tags"
                        selectionProp="TagId"
                        displayProp="Title" />

                    <p class="meta">
                        <span class="glyphicon glyphicon-time m-xs-r"></span>
                        <span>
                            <time :datetime="selectedObject.LastModified">{{ time.parse(selectedObject.LastModified) }}</time>
                        </span>
                        <span class="glyphicon glyphicon-user m-xs-r"></span>
                        <span>{{ selectedObject.LastModifiedBy.Name }}</span>
                    </p>
                </div>
            </template>

            <div class="form-group">
                <FluidButton :text="$Resources.NodeTaskChooseSurvey" @click="state.showSelectorModal = true" class="btn btn-default"></FluidButton>
            </div>
        </template>
        <template v-else-if="data.var === NodeTaskVariation.Sms">
            <template v-if="selectedObject">
                <div class="fieldset">
                    <span class="label-look">{{ $Resources.SelectedSmsLabel }}:</span>
                    <h3 class="h4 m-0-t">
                        <a :href="`/TextMessages/${selectedObject.SmsMessageId}/Statistics`" target="_blank" rel="noopener">
                            {{ selectedObject.Subject || $Resources.NoTitleLabel }}
                        </a>
                        <small class="m-xs-l">{{ selectedObject.Category?.Name }}</small>
                    </h3>

                    <SelectMany
                        v-if="selectedObject.Tags && selectedObject.Tags.length"
                        class="listing m-sm-b"
                        style="margin-left: -5px; margin-top: -10px"
                        mode="display"
                        :list="account.listings.getMap('/tags')"
                        v-model:selectedItems="selectedObject.Tags"
                        selectionProp="TagId"
                        displayProp="Title" />

                    <p class="meta">
                        <span class="glyphicon glyphicon-time"></span>
                        <span>
                            <time :datetime="selectedObject.Modified">{{ time.parse(selectedObject.Modified) }}</time>
                        </span>
                        <span class="glyphicon glyphicon-user"></span>
                        <span>{{ selectedObject.ModifiedBy.Name }}</span>
                    </p>
                </div>
            </template>

            <div class="form-group">
                <FluidButton :text="$Resources.NodeTaskChooseSms" @click="state.showSelectorModal = true" class="btn btn-default"></FluidButton>
            </div>
            <div class="form-group">
                <h3 class="h4 m-0-t d-flex col-gap-xs flex-wrap align-items-baseline">{{ $Resources.AllowResendableSmsLabel }}</h3>
                <FluidToggle
                    v-model:value="data.resendToExistingRecipients"
                    class="slide rounded mb-sm"
                    :text="$Resources.YesLabel"
                    multiple="false"></FluidToggle>
            </div>
            <div v-if="data.resendToExistingRecipients" class="form-group">
                <label for="timeSpanSince">{{ $Resources.AllowResendableSmsTimeInterval }}</label>
                <input
                    type="number"
                    class="form-control"
                    :class="{ invalid: timeSpanSinceInvalid }"
                    :value="timeSpanSince"
                    @change="(event) => handleTimeSpanSinceChange(event.currentTarget.value)"
                    :placeholder="$Resources.SegmentPropertyValuePlaceholder" />
            </div>
        </template>
        <template v-else>
            <template v-if="selectedObject">
                <div class="fieldset">
                    <span class="label-look">{{ $Resources.SelectedEmailLabel }}:</span>

                    <h3 class="h4 m-0-t d-flex col-gap-xs flex-wrap align-items-baseline">
                        <a :href="`/Issues/${selectedObject.IssueId}/Statistics`" target="_blank" rel="noopener">
                            {{ selectedObject.Subject || $Resources.NoTitleLabel }}
                        </a>
                        <small>{{ selectedObject.Category.Name }}</small>
                        <a
                            class="btn btn-subtle btn-xs"
                            :href="`${api.settings.publicHost}/Issues/${selectedObject.IssueId}?preview=true`"
                            target="_blank"
                            rel="noopener">
                            <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
                            <span class="sr-only">{{ $Resources.PreviewButton }}</span>
                        </a>
                    </h3>

                    <p class="m-xs-b" v-if="selectedObject.IssueName">
                        {{ selectedObject.IssueName }}
                    </p>

                    <template v-if="selectedObjectStats && selectedObjectStats.RecipientCount > 0">
                        <div class="ug-bars row">
                            <div class="col-md-3 col-sm-6 col-xs-3">
                                <div class="bar-label">
                                    {{ $Resources.JourneyListStatsContactsLabel }}
                                    <span>{{ selectedObjectStats.SentCount }}</span>
                                </div>
                              
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3">
                                <div class="bar-label">
                                    {{ $Resources.JourneyListStatsRecipientsLabel }}
                                    <span>{{ selectedObjectStats.RecipientCount }}</span>
                                </div>
                              
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3">
                                <div class="bar-label">
                                    {{ $Resources.IssuesOpenedPercentageLabel }}
                                    <span>{{ selectedObjectStats.RecipientCount ? Math.round((selectedObjectStats.OpenCount / selectedObjectStats.RecipientCount) * 100) + '%' : '0%' }}</span>
                                </div>
                                <div class="bar">
                                    <span 
                                        :style="{ width: selectedObjectStats.RecipientCount ? Math.min(100, Math.round((selectedObjectStats.OpenCount / selectedObjectStats.RecipientCount) * 100)) + '%' : '0%' }" 
                                        class="bar-value bg-opened"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3">
                                <div class="bar-label">
                                    {{ $Resources.IssuesClickedPercentageLabel }}
                                    <span>{{ selectedObjectStats.RecipientCount ? Math.round((selectedObjectStats.ClickCount / selectedObjectStats.RecipientCount) * 100) + '%' : '0%' }}</span>
                                </div>
                                <div class="bar">
                                    <span 
                                        :style="{ width: selectedObjectStats.RecipientCount ? Math.min(100, Math.round((selectedObjectStats.ClickCount / selectedObjectStats.RecipientCount) * 100)) + '%' : '0%' }" 
                                        class="bar-value bg-clicked"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <SelectMany
                        v-if="selectedObject.Tags && selectedObject.Tags.length"
                        class="listing m-sm-b"
                        style="margin-left: -5px; margin-top: -10px"
                        mode="display"
                        :list="account.listings.getMap('/tags')"
                        v-model:selectedItems="selectedObject.Tags"
                        selectionProp="TagId"
                        displayProp="Title" />

                    <p class="meta">
                        <span class="glyphicon glyphicon-time m-xs-r"></span>
                        <span>
                            <time :datetime="selectedObject.LastModified">{{ time.parse(selectedObject.LastModified) }}</time>
                        </span>
                        <span class="glyphicon glyphicon-user m-xs-r"></span>
                        <span>{{ selectedObject.LastModifiedBy.Name }}</span>
                    </p>
                </div>
            </template>

            <div class="form-group">
                <FluidButton :text="$Resources.NodeTaskChooseIssue" @click="state.showSelectorModal = true" class="btn btn-default"></FluidButton>
            </div>
            <div class="form-group">
                <h3 class="h4 m-0-t d-flex col-gap-xs flex-wrap align-items-baseline">{{ $Resources.AllowResendableIssueLabel }}</h3>
                <FluidToggle
                    v-model:value="data.resendToExistingRecipients"
                    class="slide rounded mb-sm"
                    :text="$Resources.YesLabel"
                    multiple="false"></FluidToggle>
            </div>
            <div v-if="data.resendToExistingRecipients" class="form-group">
                <label for="timeSpanSince">{{ $Resources.AllowResendableIssueTimeInterval }}</label>
                <input
                    type="number"
                    class="form-control"
                    :class="{ invalid: timeSpanSinceInvalid }"
                    v-model.number="timeSpanSince"
                    @blur="handleTimeSpanSinceChange(timeSpanSince?.toString())"
                    :placeholder="$Resources.SegmentPropertyValuePlaceholder" />
            </div>
        </template>
    </div>

    <Modal :title="$Resources.ChooseHeading" :show="state.showSelectorModal" @close="state.showSelectorModal = false" size="lg">
        <template #content>
            <SelectIssueFromList :items="filteredListings" :type="getType(data.var)" @update:selectedId="(newVal) => setId(data, newVal)"></SelectIssueFromList>
        </template>
    </Modal>
</template>

<style>
    /*
	.item-list {
		height: 20rem;
		overflow: scroll;
	}

	.fluid-input,
	.select-container,
	.swatch-wrapper {
		background-color: #fbffff;
		box-shadow: inset 0.2rem 0.1rem 0.2rem 0.2rem rgb(255 255 255 / 52%);
	}
    */
    .invalid {
        border-color: rgb(187, 18, 4) !important;
        box-shadow: 0 0 0 2px rgba(187, 18, 4, 0.25) !important;
    }
</style>
